import { createTheme } from '@mui/material/styles';

// Modo escuro: superfícies grafite em escala única (fundo < barra lateral <
// cartão) e azul mais claro, que passa no contraste AA sobre o cartão. O azul
// MPG #1565C0 tinha 2,4:1 sobre o cartão antigo #132F4C e sumia em links,
// botões com contorno e abas.
const ESCURO = {
    fundo: '#0E141B',
    lateral: '#121A23',
    cartao: '#17212C',
    borda: 'rgba(255,255,255,0.10)',
};

// Identidade MPG SISTEMAS — mesmo azul corporativo do sistema Revisional,
// com suporte a modo claro e escuro (alternância sem recarregar a página).
const buildTheme = (mode) => {
    const escuro = mode === 'dark';
    return createTheme({
        palette: {
            mode,
            primary: escuro
                ? { main: '#4C9AEF', light: '#7DB6F4', dark: '#2E7BD6', contrastText: ESCURO.fundo }
                : { main: '#1565C0', dark: '#0D47A1', contrastText: '#fff' },
            secondary: {
                main: escuro ? ESCURO.lateral : '#102A43',   // Azul-marinho da barra lateral
                contrastText: '#fff',
            },
            success: { main: escuro ? '#66BB6A' : '#2E7D32' },
            error: { main: escuro ? '#F27573' : '#C62828' },
            warning: { main: escuro ? '#FFA726' : '#ED6C02' },
            background: escuro
                ? { default: ESCURO.fundo, paper: ESCURO.cartao }
                : { default: '#F4F6F8', paper: '#FFFFFF' },
            ...(escuro && { divider: ESCURO.borda }),
        },
        typography: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            button: {
                textTransform: 'none',
                fontWeight: 600,
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: '8px',
                        boxShadow: 'none',
                        '&:hover': { boxShadow: '0 4px 8px rgba(0,0,0,0.1)' },
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: escuro
                        ? {
                            borderRadius: '12px',
                            // Sem o degradê de elevação do MUI: menu, diálogo e cartão
                            // saíam cada um num tom. Borda no lugar da sombra invisível.
                            backgroundImage: 'none',
                            boxShadow: 'none',
                            border: `1px solid ${ESCURO.borda}`,
                        }
                        : {
                            borderRadius: '12px',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
                        },
                },
            },
            MuiAppBar: {
                styleOverrides: {
                    // Barra do topo com o azul da marca nos dois modos.
                    root: escuro ? { backgroundColor: '#0D47A1', color: '#fff', border: 0 } : {},
                },
            },
            MuiDrawer: {
                styleOverrides: { paper: { borderRadius: 0, ...(escuro && { border: 0, borderRight: `1px solid ${ESCURO.borda}` }) } },
            },
            // Algarismos de largura fixa nas tabelas (issue #761): horário, duração e
            // contagem alinham na coluna e o cronômetro não faz o texto tremer.
            MuiTableCell: {
                styleOverrides: { root: { fontVariantNumeric: 'tabular-nums' } },
            },
            MuiTextField: {
                defaultProps: { size: 'small' },
                styleOverrides: {
                    root: {
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: escuro ? 'rgba(255,255,255,0.03)' : '#fafafa',
                        },
                    },
                },
            },
        },
    });
};

export default buildTheme;
